import { render, staticRenderFns } from "./TenantSelector.vue?vue&type=template&id=3bbc3630&scoped=true&"
import script from "./TenantSelector.vue?vue&type=script&lang=js&"
export * from "./TenantSelector.vue?vue&type=script&lang=js&"
import style0 from "./TenantSelector.vue?vue&type=style&index=0&id=3bbc3630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc3630",
  null
  
)

export default component.exports